import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";
import {handleError} from "../../../helpers/handleError";
import router from "../../../../router";

const saveOffer = {
    namespaced: true,
    state: {
        dataSaveIsFetching: false,
        typeInfoOfferSave: "",
        headInfoOfferSave: "",
        isOfferSave: false,
        textInfoOfferSave: ""
    },
    mutations: {
        DATA_SAVE_REQUEST(state, value) {
            state.dataSaveIsFetching = value;
        },
        DATA_SAVE_SUCCESS(state, response) {
            localStorage.setItem("messageOfferSave", response.data.message);
            localStorage.setItem("textOfferSave", response.data.data.textInfo);
            router.push({ path:"/offers" });
            state.dataSaveIsFetching = false;
        },
        DATA_SAVE_FAILURE(state, error) {
            state.textInfoOfferSave = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.typeInfoOfferSave = "red";
            state.headInfoOfferSave = error.response.data.message;
            state.isOfferSave = true;
            state.dataSaveIsFetching = false;
            eventBus.$emit("saveOfferFailure", error.response.data.errors);
        },
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isOfferSave = value;
        }
    },
    actions: {
        storeOffer: function({dispatch, state}, payload) {
            state.dataSaveIsFetching = true;
            let promise = sendRequest("post", config.baseURLApi + "/offers", {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataSave", result[1])
                } else {
                    dispatch("failureDataSave", result[1]);
                }
                state.dataSaveIsFetching = false;
            });
        },
        requestDataSave: function({commit}, value) {
            commit("DATA_SAVE_REQUEST", value);
        },
        successDataSave: function({dispatch, commit}, response) {
            if (response.data.data.offer) {
                dispatch('manageEmailForm/setDocumentType', 'offer', {root:true})
                dispatch('manageEmailForm/setDocumentId', response.data.data.offer.id, {root:true})
                dispatch('manageEmailForm/updateIsEmailFormVisible', true, {root:true})
            } else {
                commit("DATA_SAVE_SUCCESS", response);
            }  
        },
        failureDataSave: function({commit}, error) {
            commit("DATA_SAVE_FAILURE", error);
        },
        updateVisibleModalSave: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL", value);
        }
    }
}

export default saveOffer;